export const FETCH_ORGANIZATION = 'FETCH_ORGANIZATION'
export const FETCH_ORGANIZATION_FAILED = 'FETCH_ORGANIZATION_FAILED'
export const FETCH_ORGANIZATION_SUCCEEDED = 'FETCH_ORGANIZATION_SUCCEEDED'

export const fetchOrganization = () => ({
  type: FETCH_ORGANIZATION,
})
